const ContactBody = () => {
  return (
    <section className=" section-spacing-80 no-padding-top">
      <div className="container">
        <div className="large">
          <div className="section-content-container">
            <ul className="section-cta-options-container">
              <li>
                <h4>Call US</h4>
                <a href="tel:+256775866449" className="boldTitle">
                  +256-775-866-449
                </a>
              </li>
              <li>
                <h4>Email Us</h4>
                <a href="mailto:flexipainters@gmail.com" className="boldTitle">
                  info@flexipainters.com
                </a>
              </li>
              <li>
                <h4>Chat with Us</h4>
                <a
                  href="https://wa.me/256775866449"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="boldTitle"
                >
                  24/7 WhatsApp Chat
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactBody;
